import { useEffect, useState } from 'react';
import { getLayoutImageDataUrl } from '../utils/layouts/getLayoutImageDataUrl';

// Decodes a base64 bitmap (canvas/object backgroundImage) into an
// HTMLImageElement for a Konva Image node; undefined until loaded (or when
// there is no/broken bitmap — the caller just skips the node).
export const useLayoutImage = (
  base64: string | null | undefined
): HTMLImageElement | undefined => {
  const [image, setImage] = useState<HTMLImageElement | undefined>(undefined);

  useEffect(() => {
    if (!base64) {
      setImage(undefined);
      return;
    }

    const nextImage = new Image();
    nextImage.onload = () => setImage(nextImage);
    nextImage.onerror = () => setImage(undefined);
    nextImage.src = getLayoutImageDataUrl(base64);

    return () => {
      nextImage.onload = null;
      nextImage.onerror = null;
    };
  }, [base64]);

  return image;
};
